import React from 'react';
import {Layout, Tabs, Menu, Space } from 'antd';
import AttestationDemo from "./Demos/AttestationDemo";
import PDFImportDemo from "./Demos/PDFImportDemo";

const { SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;

const { TabPane } = Tabs;

class DemoApp extends React.Component {

    render() {
        return (
            <Layout>
                <Header className="header">
                    <div className="logo" />
                    {/*<Menu theme="light" mode="horizontal" defaultSelectedKeys={['2']}>*/}
                    {/*    <Menu.Item key="1">nav 1</Menu.Item>*/}
                    {/*    <Menu.Item key="2">nav 2</Menu.Item>*/}
                    {/*    <Menu.Item key="3">nav 3</Menu.Item>*/}
                    {/*</Menu>*/}
                </Header>
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                <Tabs tabPosition="left">
                    <TabPane tab="PDF Import Demo" key="2">
                        <PDFImportDemo/>
                    </TabPane>
                    <TabPane tab="Attestation Demo" key="1">
                        <AttestationDemo/>
                    </TabPane>

                </Tabs>
                </Content>
                <Footer style={{ textAlign: 'center' }}>
                    TMA, 10 Derne Street, Boston, MA, 02114, United States, info@tmaccelerator.com
                    Copyright (c) 2022 TMA
                </Footer>
            </Layout>
        );
    }
}



export default DemoApp;
